import {
    call, put, takeEvery, select,
} from 'redux-saga/effects';
import { editGroupModulePermissions } from '../../requests/edit_group_module_permissions_request';
import { editGroupModelPermissionsSuccess, editGroupModelPermissionsFailure } from '../actions/edit_group_model_permissions.actions';
import { EDIT_GROUP_MODEL_PERMISSIONS_REQUEST } from '../constants/edit_group_data.constants';
import { message_error, message_success } from '../../../../../components/Message';

function* editGroupModelPermissionsSagaRequest({ url, permissions, entity }) {
    const { UserManagement: { User_group_update: { group_id } } } = yield select();

    const { result, options, error } = yield call(editGroupModulePermissions, group_id, url, permissions, entity);
    if (result) {
        yield put(editGroupModelPermissionsSuccess({ options, url, entity }));
        message_success('Permission changed successfully!');
    } else {
        yield put(editGroupModelPermissionsFailure(error));
        message_error(error);
    }
}

export default function* editGroupModelPermissionsSaga() {
    yield takeEvery(EDIT_GROUP_MODEL_PERMISSIONS_REQUEST, editGroupModelPermissionsSagaRequest);
}



// WEBPACK FOOTER //
// ./src/modules/UserManagement/User_group_update/redux/sagas/edit_group_model_permissions.saga.js